import React, { useState } from 'react'
import parse from "html-react-parser";

export default function ParseHTML({inputHtml}) {
    const transformedHtml = ()=>{
    let textNodeList = []
    parse(inputHtml, {
        replace: (node) => {
            if (node.type === 'text') {
            // Only return the text content
            textNodeList.push(node.data)
            return node.data;
            }
        },
    })
    return textNodeList.join(" ")
};

const data = transformedHtml()

  return (
    <>
      {data}
    </>
  )
}
